import { render, staticRenderFns } from "./AdminSettingsMap.vue?vue&type=template&id=71cb296d&scoped=true&"
import script from "./AdminSettingsMap.vue?vue&type=script&lang=js&"
export * from "./AdminSettingsMap.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingsMap.vue?vue&type=style&index=0&id=71cb296d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cb296d",
  null
  
)

export default component.exports